import { render, staticRenderFns } from "./TagsSubTree.vue?vue&type=template&id=1cb14a10&scoped=true&"
import script from "./TagsSubTree.vue?vue&type=script&lang=js&"
export * from "./TagsSubTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb14a10",
  null
  
)

export default component.exports